<template>
  <div
    class="fixed bg-black-20 transition-opacity duration-500"
    :class="{
      'pointer-events-none opacity-0': !show || !mounted,
      'inset-0': inset,
    }"
    @click.prevent="$emit('click')"
  ></div>
</template>

<script setup lang="ts">
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  inset: {
    type: Boolean,
    default: true,
  },
})

defineEmits(['click'])

const mounted = ref(false)

onMounted(() => {
  setTimeout(() => (mounted.value = true))
})
</script>
